import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FuseProgressBarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { TabPreferencesComponent } from './tab-preferences.component';


@NgModule({
    declarations: [
        TabPreferencesComponent
    ],
    imports: [
        TranslateModule,

        FuseSharedModule,
        FuseProgressBarModule,

        MatSlideToggleModule,
        NgxMaskModule.forRoot(),
    ],
    exports: [
        TabPreferencesComponent
    ]
})
export class TabPreferencesModule { }
